// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(min-width: 1025px)";
var _3 = "(max-width: 1024px)";
var _4 = "screen and (max-width: 600px)";
var _5 = "baggage_full-1yYje";
var _6 = "baggage_included-2yOUG";
var _7 = "baggage_isSelected-24JX_";
var _8 = "baggage_fullSizeItems-32ebp";
var _9 = "services__switcher--mJa-";
var _a = "segment__direction-3jlgU";
var _b = "baggage__services-VrN14";
var _c = "baggage__services_simple-HRLGd";
var _d = "baggage__checkbox-1BmqV";
var _e = "add__button-1aVr1";
var _f = "baggage__icon_notSelected-2julC";
var _10 = "baggage__notSelected-A0CTW";
var _11 = "baggage-2prGG";
var _12 = "carryon-1XU_P";
var _13 = "baggage__size-2CuNe";
var _14 = "service-1CtKQ";
var _15 = "segment-2T8FL";
var _16 = "content-hQJLm";
var _17 = "baggage__icon_md-5NxGG";
var _18 = "baggage__icon_included-3p3r0";
var _19 = "baggage__icon_lg-1yscT";
var _1a = "baggage__icon_selected-jqnFS";
var _1b = "segment__value-24Its";
var _1c = "additional__wrapper-m5vM2";
var _1d = "baggageIcon__carry_on-2ZeGk";
var _1e = "baggageIcon__small-hfQy1";
var _1f = "baggageIcon__wrapper-2Kfd-";
var _20 = "baggageIcon__large-3esbK";
var _21 = "baggageIcon__size-3-Ksj";
var _22 = "baggage__root-1ExWX";
var _23 = "baggage__selected-326ff";
var _24 = "baggage__icon-33LeR";
var _25 = "header__passenger-1RniB";
var _26 = "header__passenger__icon-1WZ4W";
var _27 = "baggage__addButton-2G1uy";
var _28 = "baggage__addButton_add-1lSOa";
export { _1 as "__esModule", _2 as "laptop", _3 as "tablet", _4 as "mobile", _5 as "baggage_full", _6 as "baggage_included", _7 as "baggage_isSelected", _8 as "baggage_fullSizeItems", _9 as "services__switcher", _a as "segment__direction", _b as "baggage__services", _c as "baggage__services_simple", _d as "baggage__checkbox", _e as "add__button", _f as "baggage__icon_notSelected", _10 as "baggage__notSelected", _11 as "baggage", _12 as "carryon", _13 as "baggage__size", _14 as "service", _15 as "segment", _16 as "content", _17 as "baggage__icon_md", _18 as "baggage__icon_included", _19 as "baggage__icon_lg", _1a as "baggage__icon_selected", _1b as "segment__value", _1c as "additional__wrapper", _1d as "baggageIcon__carry_on", _1e as "baggageIcon__small", _1f as "baggageIcon__wrapper", _20 as "baggageIcon__large", _21 as "baggageIcon__size", _22 as "baggage__root", _23 as "baggage__selected", _24 as "baggage__icon", _25 as "header__passenger", _26 as "header__passenger__icon", _27 as "baggage__addButton", _28 as "baggage__addButton_add" }
export default { "__esModule": _1, "laptop": _2, "tablet": _3, "mobile": _4, "baggage_full": _5, "baggage_included": _6, "baggage_isSelected": _7, "baggage_fullSizeItems": _8, "services__switcher": _9, "segment__direction": _a, "baggage__services": _b, "baggage__services_simple": _c, "baggage__checkbox": _d, "add__button": _e, "baggage__icon_notSelected": _f, "baggage__notSelected": _10, "baggage": _11, "carryon": _12, "baggage__size": _13, "service": _14, "segment": _15, "content": _16, "baggage__icon_md": _17, "baggage__icon_included": _18, "baggage__icon_lg": _19, "baggage__icon_selected": _1a, "segment__value": _1b, "additional__wrapper": _1c, "baggageIcon__carry_on": _1d, "baggageIcon__small": _1e, "baggageIcon__wrapper": _1f, "baggageIcon__large": _20, "baggageIcon__size": _21, "baggage__root": _22, "baggage__selected": _23, "baggage__icon": _24, "header__passenger": _25, "header__passenger__icon": _26, "baggage__addButton": _27, "baggage__addButton_add": _28 }
